import React from 'react';
import { Circle, AlertTriangle, XCircle, Settings } from 'lucide-react';
import { cn } from '@/utils/cn';

export type SystemStatusType = 'healthy' | 'warning' | 'error' | 'maintenance';

export interface SystemStatusProps {
  status: SystemStatusType;
  label: string;
  className?: string;
  showLabel?: boolean;
}

const statusConfig = {
  healthy: {
    icon: Circle,
    color: 'text-green-500',
    bgColor: 'bg-green-100',
    label: 'Healthy',
    description: 'All systems operational'
  },
  warning: {
    icon: AlertTriangle,
    color: 'text-yellow-500',
    bgColor: 'bg-yellow-100',
    label: 'Warning',
    description: 'Some issues detected'
  },
  error: {
    icon: XCircle,
    color: 'text-red-500',
    bgColor: 'bg-red-100',
    label: 'Error',
    description: 'System issues detected'
  },
  maintenance: {
    icon: Settings,
    color: 'text-blue-500',
    bgColor: 'bg-blue-100',
    label: 'Maintenance',
    description: 'System under maintenance'
  }
};

export const SystemStatus: React.FC<SystemStatusProps> = ({
  status,
  label,
  className,
  showLabel = true
}) => {
  const config = statusConfig[status];
  const Icon = config.icon;

  return (
    <div 
      className={cn('flex items-center gap-2', className)}
      title={`${label}: ${config.description}`}
    >
      <div className={cn(
        'flex items-center justify-center w-6 h-6 rounded-full',
        config.bgColor
      )}>
        <Icon className={cn('w-3 h-3', config.color)} />
      </div>
      {showLabel && (
        <span className="text-sm text-gray-600">
          {label}
        </span>
      )}
    </div>
  );
};

export default SystemStatus;